import React, { useState } from 'react';
import { IconButton, makeStyles, Toolbar, Button, Avatar, Menu, MenuItem, Typography } from '@material-ui/core'
import { Menu as MenuIcon, Translate as TranslateIcon, KeyboardArrowDown as DownIcon } from '@material-ui/icons/'
import moment from 'moment';
import { Auth } from "aws-amplify";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({

    spam_2: {
      marginRight: theme.spacing(2),
    },
    flexGrow: {
      flexGrow: 1,
    },
    flex: {
        display: "flex"
    },
    inputRoot: {
      color: 'inherit',
    },
    lang: {
      marginLeft: theme.spacing(1),
    },
    avatar: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
  }));

interface Props {
    onSidebarOpen?: (e: React.MouseEvent<HTMLButtonElement,MouseEvent>)=>void
    onReload?: (e: React.MouseEvent<HTMLButtonElement,MouseEvent>)=>void
    onSearch?: (keyword: string)=>void
    updateAt: moment.Moment
}

function Header(props: Props) {

    const classes = useStyles()
    const [t, i18n] = useTranslation()

    const [lang, setLang] = useState<HTMLElement|undefined>(undefined)
    const [menu, setMenu] = useState<HTMLElement|undefined>(undefined)

    const handleMenu = (e: React.MouseEvent<HTMLElement>) => {
      setMenu(e.currentTarget)
    }
    const handleLang = (e: React.MouseEvent<HTMLElement>) => {
      setLang(e.currentTarget)
    }
    const changeLanguage = (language: string) => {
      i18n.changeLanguage(language)
      setLang(undefined)
    }
    return (
        
        <Toolbar>
            <IconButton edge="start" color="inherit" className={classes.spam_2} aria-label="menu" onClick={(e)=>props.onSidebarOpen?.(e)}>
                <MenuIcon />
            </IconButton>
            <Typography variant="h6">
              {t("message.header.brand")}
            </Typography>
            <div className={classes.flexGrow}>
            </div>
            <Button color="inherit" onClick={handleLang}>
              <TranslateIcon />
              <span className={classes.lang}>
              { 
                i18n.language === "ja" ? "日本語" :
                i18n.language === "en" ? "English" :
                "日本語"
              }
              </span>
              <DownIcon />
            </Button>
            <Menu
              anchorEl={lang}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={lang !== undefined}
              onClose={()=>setLang(undefined)}
            >
              <MenuItem onClick={()=>changeLanguage("ja")}>日本語</MenuItem>
              <MenuItem onClick={()=>changeLanguage("en")}>English</MenuItem>
            </Menu>
            <Button color="inherit" onClick={handleMenu}>
              <Avatar className={classes.avatar}></Avatar>
            </Button>
            <Menu
              anchorEl={menu}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={menu !== undefined}
              onClose={()=>setMenu(undefined)}
            >
              <MenuItem onClick={()=>Auth.signOut()}>{t("message.header.logout")}</MenuItem>
            </Menu>
        </Toolbar>
    )
}

export default Header;